import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { ItemsAdministrativeInfo } from 'src/app/model/configuration';
import { Feature, OptionInfo } from 'src/app/model/feature';
import { IndustryProductID, OptionAvailability } from 'src/app/model/industry';
//import { OptionAvailability } from 'src/app/model/industry';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ConfigurationService } from 'src/app/store/store.module';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';
//const MWFragmentWeights = require('src/app/portal/magoweb-management/mw-fragment-weights.json');

@Component({
    selector: 'ms-cal-selection',
    templateUrl: './cal-selection.component.html',
    styleUrls: ['./cal-selection.component.scss'],
})
export class CalSelectionComponent implements OnInit {
    @Input() CALFeature: Feature[];
    @Input() productID: string = '';
    @Output() featureClicked = new EventEmitter<Feature>();
    editionSelected: string = 'pro';
    currency: string = '';
    public smallScreen: boolean = false;

    constructor(
        public magoWebService: MagoWebService,
        public magoCloudService: MagoCloudService,
        public storeRoleService: StoreRolesService,
        private breakpointObserver: BreakpointObserver
    ) {
        if (this.productID == IndustryProductID.MW) {
            this.editionSelected =
                this.magoWebService.currIndustryPurchInfo && this.magoWebService.currIndustryPurchInfo.Edition
                    ? this.magoWebService.currIndustryPurchInfo.Edition.EditionCode
                    : this.editionSelected;
        } else {
            this.editionSelected =
                this.magoCloudService.currIndustryPurchInfo && this.magoCloudService.currIndustryPurchInfo.Edition
                    ? this.magoCloudService.currIndustryPurchInfo.Edition.EditionCode
                    : this.editionSelected;
        }
    }

    ngOnInit() {
        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.smallScreen = result.matches;
        });
    }

    public getDescription(feature: Feature) {
        return feature.Description == '' ? 'manca descrizione modulo' : feature.Description;
    }

    handleOptionMinus(feature: Feature) {
        if (feature.CurrNrOfUser > 0) {
            feature.CurrNrOfUser--;
            feature.isChecked = true;
        } else {
            feature.CurrNrOfUser = 0;
            feature.isChecked = false;
        }
        this.updateconfig(feature);
        this.featureClicked.emit(feature);
    }
    handleOptionPlus(feature: Feature) {
        feature.CurrNrOfUser++;
        feature.isChecked = true;
        this.updateconfig(feature);
        this.featureClicked.emit(feature);
    }

    updateconfig(feature: Feature) {
        let isCountable;
        if (this.productID == IndustryProductID.MW) {
            isCountable =
                feature.Options.findIndex(
                    (x) =>
                        x.edition.toLowerCase() == this.magoWebService.currIndustryPurchInfo.Edition.EditionCode &&
                        x.availability.toLowerCase() === OptionAvailability.COUNT
                ) > -1;
            if (isCountable) feature.isChecked = feature.CurrNrOfUser > 0;
            this.magoWebService.setCalFullNr(feature);
        } else {
            isCountable =
                feature.Options.findIndex(
                    (x) =>
                        x.edition.toLowerCase() == this.magoCloudService.currIndustryPurchInfo.Edition.EditionCode &&
                        x.availability.toLowerCase() === OptionAvailability.COUNT
                ) > -1;
            if (isCountable) feature.isChecked = feature.CurrNrOfUser > 0;
            this.magoCloudService.setCalFullNr(feature);
        }
        this.manageOptionInfo(feature);
        this.featureClicked.emit(feature);
    }

    manageOptionInfo(optFeature: Feature) {
        let isMagoWeb = this.productID == IndustryProductID.MW;
        if (optFeature != null) {
            //let price = optFeature.pr;
            // if (elem.type == 'checkbox') {
            if (optFeature.isChecked) {
                //let featurePrice: number = this.getPrice(optFeature);
                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = this.editionSelected;
                //t.price = featurePrice;
                t.optionID = optFeature.OptionID;
                t.fragment = optFeature.Fragment;
                t.nrOfUser = optFeature.CurrNrOfUser;

                let isCountable =
                    optFeature.Options.findIndex(
                        (x) => x.edition.toLowerCase() == this.editionSelected && x.availability.toLowerCase() === OptionAvailability.COUNT
                    ) > -1;

                if (isCountable) {
                    let f = isMagoWeb ? this.magoWebService.CALCountableFeatureSelected : this.magoCloudService.CALCountableFeatureSelected;
                    let index = f.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == this.editionSelected.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        isMagoWeb
                            ? this.magoWebService.CALCountableFeatureSelected.push(optFeature)
                            : this.magoCloudService.CALCountableFeatureSelected.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        isMagoWeb
                            ? this.magoWebService.CALCountableFeatureSelected.splice(index, 1, optFeature)
                            : this.magoCloudService.CALCountableFeatureSelected.splice(index, 1, optFeature);
                    }

                    let optionInfo = isMagoWeb ? this.magoWebService.selectedOptionInfo : this.magoCloudService.selectedOptionInfo;
                    index = optionInfo.findIndex((x) => x.optionID == optFeature.OptionID);
                    let ofoi = isMagoWeb
                        ? this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo
                        : this.magoCloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
                    let indexOfoi = ofoi.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (index == -1) {
                        isMagoWeb ? this.magoWebService.selectedOptionInfo.push(t) : this.magoCloudService.selectedOptionInfo.push(t);
                    } else {
                        isMagoWeb
                            ? this.magoWebService.selectedOptionInfo.splice(index, 1, t)
                            : this.magoCloudService.selectedOptionInfo.splice(index, 1, t);
                    }
                    if (indexOfoi == -1)
                        isMagoWeb
                            ? this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t)
                            : this.magoCloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    else {
                        isMagoWeb
                            ? this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.splice(indexOfoi, 1, t)
                            : this.magoCloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo.splice(indexOfoi, 1, t);
                    }

                    if (isMagoWeb) {
                        //aggiungo le FL alle countable
                        this.magoWebService.CALCountableFeatureSelected.forEach((element) => {
                            let index = this.magoWebService.currIndustryPurchInfo.CountableFeatures.findIndex(
                                (x) => x.OptionID == element.OptionID
                            );
                            if (index == -1) this.magoWebService.currIndustryPurchInfo.CountableFeatures.push(element);
                            else this.magoWebService.currIndustryPurchInfo.CountableFeatures.splice(index, 1, element);
                        });
                    } else {
                        this.magoCloudService.CALCountableFeatureSelected.forEach((element) => {
                            let index = this.magoCloudService.currIndustryPurchInfo.CountableFeatures.findIndex(
                                (x) => x.OptionID == element.OptionID
                            );
                            if (index == -1) this.magoCloudService.currIndustryPurchInfo.CountableFeatures.push(element);
                            else this.magoCloudService.currIndustryPurchInfo.CountableFeatures.splice(index, 1, element);
                        });
                    }
                }
            } else {
                this.removeFromSelectedFeature(optFeature, this.editionSelected, isMagoWeb);
                this.removeFromSelectedOptionInfo(optFeature, this.editionSelected, isMagoWeb);
            }
        }
    }
    removeFromSelectedFeature(optFeature: Feature, selectedEdition: string, isMagoWeb: boolean) {
        let f = isMagoWeb
            ? this.magoWebService.currIndustryPurchInfo.OptionalFeatures
            : this.magoCloudService.currIndustryPurchInfo.OptionalFeatures;
        let index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            if (isMagoWeb) this.magoWebService.currIndustryPurchInfo.OptionalFeatures = f;
            else this.magoCloudService.currIndustryPurchInfo.OptionalFeatures = f;
        }

        f = isMagoWeb
            ? this.magoWebService.currIndustryPurchInfo.CountableFeatures
            : this.magoCloudService.currIndustryPurchInfo.CountableFeatures;
        index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            if (isMagoWeb) this.magoWebService.currIndustryPurchInfo.CountableFeatures = f;
            else this.magoCloudService.currIndustryPurchInfo.CountableFeatures = f;
        }
        f = isMagoWeb ? this.magoWebService.currIndustryPurchInfo.PptFeatures : this.magoCloudService.currIndustryPurchInfo.PptFeatures;
        index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            if (isMagoWeb) this.magoWebService.currIndustryPurchInfo.PptFeatures = f;
            else this.magoCloudService.currIndustryPurchInfo.PptFeatures = f;
        }
        f = isMagoWeb ? this.magoWebService.CALCountableFeatureSelected : this.magoCloudService.CALCountableFeatureSelected;
        index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            if (isMagoWeb) this.magoWebService.CALCountableFeatureSelected = f;
            else this.magoCloudService.CALCountableFeatureSelected = f;
        }
    }

    removeFromSelectedOptionInfo(optFeature: Feature, selectedEdition: string, isMagoWeb: boolean) {
        let t = isMagoWeb
            ? this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo
            : this.magoCloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
        let i = t.findIndex((x) => x.optionID == optFeature.OptionID && x.selectedEdition.toLowerCase() == selectedEdition.toLowerCase());
        if (i != -1) {
            t.splice(i, 1);
            if (isMagoWeb) this.magoWebService.currIndustryPurchInfo.OptionalFeaturesOptionInfo = t;
            else this.magoCloudService.currIndustryPurchInfo.OptionalFeaturesOptionInfo = t;
        }
        // le cal sono qui
        let cal = isMagoWeb ? this.magoWebService.selectedOptionInfo : this.magoCloudService.selectedOptionInfo;
        let index = cal.findIndex(
            (x) => x.optionID == optFeature.OptionID && x.selectedEdition.toLowerCase() == selectedEdition.toLowerCase()
        );
        if (index != -1) {
            cal.splice(index, 1);
        }
    }
}
